<template lang="pug">
  #n-calculator
    input.calculator-input.primary--text(
      v-model="localValue"
      type="string"
      @keyup.enter="onCalcResult()"
      @keydown.prevent="(e) => onDirectInput(e)"
    )

    v-row(no-gutters)
      v-col(cols="6")
        a.calculator-btn.primary.white--text(@click="onClear()") C

      v-col(cols="3")
        a.calculator-btn.primary(@click="onDelete()")
          v-icon.white--text backspace

      //- v-col(cols="3")
      //-   a.calculator-btn.light(@click="onInputFactor('%')") %

      v-col(cols="3")
        a.calculator-btn.info(@click="onInputFactor('/')") /

    v-row.mt-0(no-gutters)
      v-col(cols="3")
        a.calculator-btn(@click="onInputFactor(7)") 7

      v-col(cols="3")
        a.calculator-btn(@click="onInputFactor(8)") 8

      v-col(cols="3")
        a.calculator-btn(@click="onInputFactor(9)") 9

      v-col(cols="3")
        a.calculator-btn.info(@click="onInputFactor('*')") *

    v-row.mt-0(no-gutters)
      v-col(cols="3")
        a.calculator-btn(@click="onInputFactor(4)") 4

      v-col(cols="3")
        a.calculator-btn(@click="onInputFactor(5)") 5

      v-col(cols="3")
        a.calculator-btn(@click="onInputFactor(6)") 6

      v-col(cols="3")
        a.calculator-btn.info(@click="onInputFactor('-')") -

    v-row.mt-0(no-gutters)
      v-col(cols="3")
        a.calculator-btn(@click="onInputFactor(1)") 1

      v-col(cols="3")
        a.calculator-btn(@click="onInputFactor(2)") 2

      v-col(cols="3")
        a.calculator-btn(@click="onInputFactor(3)") 3

      v-col(cols="3")
        a.calculator-btn.info(@click="onInputFactor('+')") +

    v-row.mt-0(no-gutters)
      v-col(cols="6")
        a.calculator-btn(@click="onInputFactor(0)") 0

      v-col(cols="3")
        a.calculator-btn(@click="onInputFactor('.')") .

      v-col(cols="3")
        a.calculator-btn.info(@click="onCalcResult()") =

</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component({})
export default class NCalculator extends Vue {
  @Prop({ type: Number, default: 0 }) value
  @Watch('localValue')
  onChangeLocalValue () {
    if (!isNaN(this.localValue)) {
      this.$emit('input', parseFloat(this.localValue))
    } else {
      this.$emit('input', null)
    }
  }

  localValue = 0
  // logs = []
  rounding = Math.pow(10, 6)

  get valueString () {
    return this.localValue !== null
      ? this.localValue.toString()
      : ''
  }

  mounted () {
    this.localValue = 0
  }

  calcInputs () {
    try {
      const value = window.Function(`"use strict"; return eval("${ this.localValue }")`)()
      return isNaN(value) || value === Infinity
        ? 0
        : Math.round(value * this.rounding) / this.rounding
    } catch {
      return 0
    }
  }

  isOpeator (str) {
    const operators = [ '+', '-', '*', '/' ]
    return operators.includes(str)
  }

  onDirectInput (e) {
    const validKeys = [
      '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '+', '-', '*', '/'
    ]

    if (validKeys.includes(e.key)) {
      if (e.key >= '0' && e.key <= '9') {
        this.onInputFactor(parseInt(e.key))
      } else {
        this.onInputFactor(e.key)
      }
    }

    const funcKeys = [
      'Backspace'
    ]

    if (funcKeys.includes(e.key)) {
      this.onDelete()
    }
  }

  onInputFactor (e) {
    if (typeof this.localValue === 'number' && Number.isInteger(e)) {
      this.localValue = ''
    }

    if (this.valueString.length >= 20) {
      return
    }

    // check if last char is operator
    if (this.valueString.length > 1 && this.isOpeator(e)) {
      const lastChar = this.valueString.substring(this.valueString.length - 1)
      if (this.isOpeator(lastChar)) {
        this.localValue = this.valueString.slice(0, -1)
      }
    }
    this.localValue = this.valueString + e
  }

  onCalcResult () {
    // const log = this.localValue
    this.localValue = this.calcInputs()
    // this.logs.push(`${ log }=${ this.localValue }`)
  }

  onClear () {
    this.localValue = 0
  }

  onDelete () {
    if (!this.localValue || this.valueString.length === 1) {
      this.localValue = 0
    } else {
      this.localValue = this.valueString.slice(0, -1)
    }
  }
}
</script>

<style lang="scss">
$dark: #024589;
$light: #d7e5f8;
$white: #fff;

#n-calculator {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  width: 100%;

  .calculator-input {
    font-size: 32px;
    font-weight: 300;
    padding: 10px;
    text-align: right;

    &:focus, &:active {
      outline: none;
    }
  }

  .col {
    box-shadow: 0 0 0 1px $white;
    padding: 0;
  }

  .calculator-btn {
    display: flex;
    justify-content: center;
    background-color: $light;
    color: var(--v-primary-base);
    cursor: pointer;
    font-size: 24px;
    padding: .8rem;
    width: 100%;
    height: 100%;
    transition: all .3s ease-in-out;
    user-select: none;
  }
}
</style>
